import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { translations } from 'src/app/constants/translations';
import { TranslationsStateModel } from './translations.state-model';

const defaults: TranslationsStateModel = {
  translations: translations,
};

@State<TranslationsStateModel>({
  defaults,
  name: 'translations',
})
@Injectable()
export class TranslationsState {
  constructor() {}
}
